<template>
	<div @click="cascaderClick()" class="elCascaderConSty"
		:class="inputClass == 'inputCustom246' ? 'widthPercentage' : ''">
		<!-- @visible-change="visibleChangeHandle" -->
		<el-cascader @clear="clearHandle" @focus="focusHandle" @change="changeHandle" ref="cascaderRef"
			v-model="optionsValue" :options="optionsData" :props="optionProps" :show-all-levels="false"
			:key="cascaderKey" :clearable="clearable" :placement="placement" filterable :filter-method="filterMethod"
			:placeholder="placeholder || '请输入'" :size="size"
			:class="inputClass + (disabled ? ' pointerEventsNone' : '')" :disabled="disabled"
			popper-class="custom-cascader">
			<template #default="{ node, data }">
				<span v-if="data.departmentName == '最近指定'" class="zdIconBlo displayF8Center">
					<div>{{ data.departmentName }}</div>
					<img :src="initThemeImg(theme, 'icon_zd@2x')" alt="" class="imgHover">
					<img :src="initThemeImg(theme, 'icon_zd_gg@2x')" alt="" class="img">
				</span>
				<span v-else>{{ data.departmentName }}</span>
				<span v-if="node.isLeaf">
					({{ data.removeAccount ? '不存在' : data.account }}){{data.departmentId == 'demo' || data.departmentPid == 'demo' ? ` - ${data.lastName}` : ''}}
				</span>
			</template>
		</el-cascader>
	</div>
</template>

<script setup>
	import {
		watch
	} from 'vue'
	import {
		sysdepartmentListByCompany
	} from '@/api/archivePage'
	import {
		initThemeImg,
		setMessageQueue,
		getNotEditableShow
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		optionsVal: {
			type: Number,
			default: null
		},
		clearable: {
			type: Boolean,
			default: true
		},
		inputClass: {
			type: String,
			default: 'input240'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isSubmit: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'default' //  :size="'middle'"
		},
		companyId: {
			type: Number,
			default: null
		},
		placement: {
			type: String,
			default: 'bottom-start'
		},
		appointData: {
			type: Array,
			default: () => []
		},
		projectId: {
			type: Number,
			default: null
		},
		placeholder: {
			type: String,
			default: ''
		},
		formProject: {
			type: Number,
			default: null
		}
	})

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	const optionsValue = computed(() => {
		return props.optionsVal
	})
	// 是否可以快捷键shift+enter提交 并且不是删除时
	const isSubmit = computed(() => {
		return props.isSubmit
	})
	const appointDataValue = computed(() => {
		return props.appointData
	})

	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})

	const optionsData = ref([]) // 所有人员数据
	const optionProps = {
		value: 'departmentId',
		label: 'departmentName',
		disabled: 'removeAccount',
		emitPath: false
	}
	const cascaderRef = ref(null);
	const cascaderKey = ref(0)
	const projectIdValue = ref(null)

	// ***这里需要暴露出去不然父组件调用不到这个方法
	defineExpose({
		commonFocus
	})
	watch(appointDataValue, (arrVal) => {
		// 处理最新数据
		setNewDataHandle(arrVal)
		// 强制刷新
		refreshHandle()
	})

	watch(() => props.projectId, val => {
		projectIdValue.value = val
		// console.log(projectIdValue.value, 'props.projectId')
	})

	// 强制刷新
	function refreshHandle() {
		cascaderKey.value++ // 强制重新渲染级联选择器

		// 强制重新渲染级联选择器
		proxy.$nextTick(() => {
			if (cascaderRef.value) {
				cascaderRef.value.$forceUpdate();
			}
		});
	}

	// 处理最新数据
	function setNewDataHandle(arrVal) {
		let data = []
		if (optionsData.value.length > 0 && optionsData.value[0].departmentId === 'demo') {
			optionsData.value.shift()
		}
		data = optionsData.value
		let demo = 'demo'
		let arr = []

		// console.log(arrVal, 'arrVal')

		if (arrVal.length > 0) {
			arrVal.map(item => {
				// 确保 ID 唯一且易于识别
				const uniqueId = item.userId + demo;

				arr.push({
					departmentPid: demo,
					departmentId: uniqueId, // 使用字符串确保唯一性
					account: item.userAccount,
					departmentName: item.userName,
					lastName: item.lastName,
					removeAccount: item.removeAccount || null, // 20260610 新增优化
					// 保留原始数据以便识别
					originalData: item,
					children: null
				})
			})

			data.unshift({
				departmentPid: 0,
				departmentId: demo,
				departmentName: '最近指定',
				children: arr
			})
		}

		optionsData.value = data
		// console.log(optionsData.value, 'optionsData.valueoptionsData.value')
	}

	// tab获取焦点  num 3需求 2模块 1项目
	function commonFocus(num) {
		console.log(document.querySelectorAll('.el-input__inner'), document.querySelectorAll('.el-input__inner').length,
			'commonFocus')
		document.querySelectorAll('.el-input__inner')[document.querySelectorAll('.el-input__inner').length - (num || 1)]
			.focus()
		// console.log(document.querySelectorAll('.el-input__inner'), 'commonFocus cascader')
	}

	// 文本输入框查询 范围--成员名称/ID
	function filterMethod(option, inputValue) {
		console.log(inputValue, option.data, 'inputValue, option')
		return (option.data.departmentPid && option.data.departmentPid.toString() !== 'demo' || !option.data
			.departmentPid) && (option.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1 || option.data
			.account.toString().indexOf(inputValue) !== -1);
	}

	// // 下拉框出现/隐藏时触发 20260212注释 原最近指定回到此方法
	// function visibleChangeHandle(val) {
	// 	proxy.$emit('isVisibleHandle', val)
	// }

	// 选择人员
	function changeHandle(e) {
		// let index = optionsData.value.findIndex(value => {
		// 	console.log(value, 'changeHandle', e, ee)
		// 	return value.departmentId === e
		// })
		// let name = ''
		// if (index > -1) {
		// 	name = optionsData.value[index].departmentName
		// }
		console.log('=== 级联选择器变化 ===');
		console.log('选中的值:', e);
		console.log('当前所有数据:', optionsData.value);
		// return
		// proxy.$emit('change', e || '', name)

		// 强制刷新
		refreshHandle()

		// 取值name
		getUserName(optionsData.value, e)
	}

	function focusHandle() {
		proxy.$emit('focusHandle')
	}

	// 取值name
	function getUserName(data, e) {
		for (let i = 0; i < data.length; i++) {
			if (e === data[i].departmentId) {
				proxy.$emit('changeCascader', e || '', data[i].departmentName)
				return
			}

			if (data[i].children && data[i].children.length > 0) {
				// 取值name
				getUserName(data[i].children, e)
			}
		}
	}

	// 禁用时 点击给提示
	async function cascaderClick() {
		if (projectIdValue.value) {
			if (!props.disabled) {
				return
			}
		} else {
			return
		}

		const data = await getNotEditableShow(projectIdValue.value, '编辑')
		if (data.code === 505) {
			return
		}
	}

	// 清除事件
	function clearHandle() {
		proxy.$emit('clear')
	}

	// 获取负责人
	function sysdepartmentListByCompanyApi() {
		sysdepartmentListByCompany({
			companyId: props.companyId || '',
			formProject: props.formProject || null // 20260609新增标识 有值为项目并返回不存在数据
		}).then(res => {
			if (res) {
				let data = res.data
				optionsData.value = data

				if (props.appointData.length > 0) {
					// 处理最新数据
					setNewDataHandle(props.appointData)
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// // 监听键盘shift+enter快捷键提交
	// const handleKeyDown = (e) => {
	// 	// 弹窗显示 键盘快捷键强制失效
	// 	if (useUserStore().isModal) {
	// 		return
	// 	}

	// 	let shortcutModelArr = userConfigData.value.shortcutModelArr
	// 	console.log(isSubmit.value, 'isSubmitisSubmit')
	// 	// shift+enter快捷键提交
	// 	if (e.shiftKey && e.key === 'Enter' && isSubmit.value) {
	// 		if (shortcutModelArr.includes(1)) {
	// 			e.preventDefault();
	// 			// 直接调用创建/编辑提交
	// 			proxy.$emit('submit', 'elCascaderCommon')
	// 			e.stopPropagation();
	// 		}
	// 	}
	// };

	onBeforeUnmount(() => {
		// 20260212 注释 由于新建/编辑页已有shift+enter快捷键提交功能 此功能暂时不用了
		// window.removeEventListener('keydown', handleKeyDown, true);
	});

	onMounted(() => {
		// 获取所有人
		sysdepartmentListByCompanyApi()

		// 20260212 注释 由于新建/编辑页已有shift+enter快捷键提交功能 此功能暂时不用了
		// window.addEventListener('keydown', handleKeyDown, true);
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.zdIconBlo {

		img {
			width: 14px;
			height: 14px;
			margin-top: 1px;
		}

		.imgHover {
			display: none;
		}

		.img {
			display: block;
		}
	}

	.zdIconBlo:hover,
	.el-cascader-node.in-active-path,
	.el-cascader-node.is-active,
	.el-cascader-node.is-selectable.in-checked-path {
		.imgHover {
			display: block;
		}

		.img {
			display: none;
		}
	}

	.pointerEventsNone {
		pointer-events: none;
	}

	:deep(.el-input.is-disabled .el-input__wrapper) {
		pointer-events: none !important;

		.el-input__inner {
			pointer-events: none !important;
		}
	}

	// :deep(.el-input.is-disabled .el-input__inner) {
	// 	-webkit-text-fill-color: #FFF !important
	// }

	// :deep(.el-input.is-disabled) {
	// 	cursor: not-allowed !important;

	// 	.el-input__wrapper, .el-input__inner {
	// 		cursor: not-allowed !important;
	// 	}
	// }
</style>